export default {
  release: '17.6',
  date: 'November 2024',
  releasePostUrl: 'https://docs.gitlab.com/releases/17/gitlab-17-6-released/#this-months-notable-contributor-joel-gerber',
  contributors: [
    {
      name: 'Joel Gerber',
      gitlabUsername: 'Jitsusama',
    },
  ],
  writeUp: `Joel was recognized for being an invaluable contributor to our CI components, offering insightful feedback on merge requests,
and thoughtful comments on complex discussions.
His contributions include [UI polish for the CI/CD catalog](https://gitlab.com/gitlab-org/gitlab/-/issues/464703),
highly requested documentation improvements for the GitLab Terraform Provider, [job log timestamps](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/164595),
and [providing feedback to the UI/UX team](https://gitlab.com/gitlab-org/gitlab/-/issues/482524#note_2089551197).
 
Joel is a Staff Software Engineer at [HackerOne](https://www.hackerone.com/) and was nominated by
[Lee Tickett](https://gitlab.com/leetickett-gitlab), Staff FullStack Engineer, Contributor Success at GitLab,
for his contributions and for providing valuable feedback.

[Gina Doyle](https://gitlab.com/gdoyle), Senior Product Designer at GitLab, added to the nomination.
"There was a lot of discussion going on internally that led the MR process to be more complicated," says Gina.
"But Joel stayed strong and active within the discussion and completed the contribution."

"Joel also contributed to the UI polish on the CI/CD catalog issue," says [Sunjung Park](https://gitlab.com/sunjungp),
Staff Product Designer at GitLab.
"It makes our user interface beautiful and consistent with other areas."

We are so grateful to Joel for all of his contributions and to all of our open source community for contributing to GitLab!`,
};
